import { useEffect, useRef } from 'react';
import { Animated, StyleSheet } from 'react-native';

const SkeletonPlaceholder = ({ width, height, style }) => {
  const opacity = useRef(new Animated.Value(0.6)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 750,
          useNativeDriver: false,
        }),
        Animated.timing(opacity, {
          toValue: 0.6,
          duration: 750,
          useNativeDriver: false,
        }),
      ])
    ).start();
  }, [opacity]);

  return <Animated.View style={[styles.placeholder, { width, height }, { opacity }, style]} />;
};

const styles = StyleSheet.create({
  placeholder: {
    backgroundColor: '#E1E9EE',
    borderRadius: 4,
  },
});

export default SkeletonPlaceholder;
